import { Button, CircularProgress } from '@material-ui/core'
import { faArrowToBottom } from '@fortawesome/pro-solid-svg-icons'
import useExportHighschoolsExplore from './useExportHighschoolsExplore'
import { UIFilters, ResultOptions } from './types'
import downloadFile from 'js-file-download'
import { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { createAPIFiltersFromUIFilters } from '../filter-state-to-api-query'

export default function ExportButton({
  resultOptions,
  filters,
  columns,
}: {
  resultOptions: ResultOptions
  filters: UIFilters
  columns: { field?: string; headerName?: string }[]
}) {
  const { mutate, isSuccess, isLoading, data, reset } = useExportHighschoolsExplore()
  useEffect(() => {
    if (isSuccess && data) {
      const date = Intl.DateTimeFormat('en-US').format(new Date()).replace(/\//g, '-')
      const fileName = `high-schools-export-${date}.csv`
      downloadFile(data, fileName, 'text/csv')
      reset()
    }
  }, [isSuccess, data, reset])

  return (
    <Button
      color="primary"
      disabled={isLoading}
      onClick={() => {
        mutate({
          resultOptions: resultOptions,
          filters: createAPIFiltersFromUIFilters(filters),
          columns: columns.map((column) => ({
            field: column.field || '',
            heading: column.headerName || '',
          })),
        })
      }}
      startIcon={
        isLoading ? (
          <div>
            <CircularProgress size={16} />
          </div>
        ) : (
          <FontAwesomeIcon icon={faArrowToBottom} />
        )
      }
    >
      Export
    </Button>
  )
}
